import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedOtherWorkEventListViewList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseOtherWorkEvents {
  year?: number;
  month?: number;
  staff?: string;
  ordering?: string;
  limit?: string;
}

function useOtherWorkEvents({
  year,
  month,
  staff,
  ordering,
  limit = '20',
}: IUseOtherWorkEvents): UseInfiniteQueryResult<AxiosResponse<PaginatedOtherWorkEventListViewList>> {
  const fetchOtherWorkEvents = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedOtherWorkEventListViewList>> => {
      const params = pageParam;

      if (year) params.year = String(year);
      if (month) params.month = String(month);
      if (staff) params.staff = staff;

      if (ordering) {
        const snakeOrdering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        params.ordering = snakeOrdering;
      }

      return client.get(`other-work-events/?${encodeUrlParams(params)}`);
    },
    [limit, year, month, staff, ordering],
  );

  return useInfiniteQuery(['otherWorkEvents', year, month, staff, ordering], fetchOtherWorkEvents, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useOtherWorkEvents;
